import packageJson from "./../../package.json";

//Variables de Contacto
export const GPW_EMAIL = '';
export const GPW_PHONE = '';
export const GPW_EXTENSION = '';
export const FORBIDDEN_APP_MESSAGE = `Usted no cuenta con los permisos necesarios para acceder a esta aplicación. Comuníquese con Mesa de Ayuda (e-mail: ${GPW_EMAIL}) para solicitar acceso`;
export const NOMBRE_SISTEMA = 'MI PERFIL';
export const LOGO_SIDE_SISTEMA = 'assets/images/LS_MS.jpg';
export const LOGO_SISTEMA = 'assets/images/LS_MS_2.png';
export const LOGO_SISTEMA_TEXTO = '';

//Metodos de Login
export const LOGINS = [
    { tipo: 'LOG_ClaveUnica', value: '', predeterminado: '', imagen: 'assets/libs/login/fonts/cu-color.png', texto: 'CLAVE ÚNICA'},
    { tipo: 'LOG_JunjiAD', value: '1', predeterminado: '1', imagen: 'assets/libs/login/fonts/junjilogo.svg', texto: 'JUNJI AD'},
    { tipo: 'LOG_CorreoMicrosoft', value: '', predeterminado: '', imagen: 'assets/libs/login/fonts/microsoft.svg', texto: 'MICROSOFT'},
    { tipo: 'LOG_CorreoGoogle', value: '', predeterminado: '', imagen: 'assets/libs/login/fonts/google.svg', texto: 'GOOGLE'},
    { tipo: 'LOG_UsuarioLocal', value: '', predeterminado: '', imagen: 'assets/libs/login/fonts/usuario-local.png', texto: 'USUARIO LOCAL'},
    { tipo: 'LOG_UsuarioGesdep', value: '', predeterminado: '', imagen: 'assets/libs/login/fonts/gesdep-color.png', texto: 'GESDEP'}
  ];

// SSO url
export const authorizerUrl = 'https://ssomiddleqa.azurewebsites.net';

//Variables de Entorno
export const environment = {
    ambiente: 'DEV',
    production: false,
    appVersion: packageJson.verion_app,
    templateVersion: packageJson.version,
    idSistema: 'eaf7fcb7d57f0e5e8386ae4f1bb8b69d73d04c6cdbc3', // coincidir con clientId mas abajo si esta activo (este id lo crea JUNJI)
    apiKeyCargaUsuarios: '!"#$%&/()=123456789Qwerty',
    apiKeyIntranet: 'nN3947Brfd/%&',
    
    authorizer: {
        usarSso: true,
        authorizerUrlExternal: `${authorizerUrl}/external`,
        authorizeUrl: `${authorizerUrl}/connect/authorize`,
        tokenUrl: `${authorizerUrl}/connect/token`,
        userInfoUrl: `${authorizerUrl}/connect/userinfo`,
        endSessionUrl: `${authorizerUrl}/connect/endsession`,        
        scope: 'openid email',
        responseType: ['code', 'token'],
        grantType: ['authorization_code'],
        tenantId: '93053F8F-8ACE-4ED3-881A-E348545F22B6',
        responseMode: 'fragment',
        // Acá se debe cambiar según datos de propio sistema
        clientId: 'eaf7fcb7d57f0e5e8386ae4f1bb8b69d73d04c6cdbc3',
        clientKey: 'yKRercE8xXHbPd74qRsR20ZyiaDfRFwPpGEcpcS65cg=',
        apikeysso: 'pNXO0YyjAb7K0FfcbkRonjt4pV1mFKoi',
        returnUrl: 'https://miperfildev.junji.gob.cl/auth/callback',
        logoutUrl: 'https://miperfildev.junji.gob.cl/',
    }
};

//Datos de Servicios
export const BASE_URL_SERVICIOS_LOGIN : string = 'https://dockerdev.junji.gob.cl';
export const BASE_URL_SERVICIOS_USUARIOS : string = 'https://dockerdev.junji.gob.cl';
export const BASE_URL_SERVICIOS_CORESERVICE : string = 'https://loadbalancer01.junji.gob.cl';
export const BASE_URL_SERVICIOS_BACK : string = 'https://dockerdev.junji.gob.cl';

//Variables de Sistema
export const SideNavOpn : number = 240;
export const SideNavCls : number = 105;